'use client';

import { useRef, useState } from 'react';

import { Button, Flex, Spacer } from '@backyard-ui/core';

import { Markdown } from '@/presenters/components/common/Markdown';

import { MAX_HEIGHT } from './constants';
import styles from './FullDescription.styles';
import useIsCollapsable from './useIsCollapsable';

interface FullDescriptionProps {
  content: string;
}

export default function FullDescription(props: Readonly<FullDescriptionProps>) {
  const { content } = props;

  const ref = useRef<HTMLDivElement>(null);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const isCollapsable = useIsCollapsable(ref);

  const classNames = styles({ isCollapsable, isCollapsed });

  return (
    <Flex direction="column">
      <div
        className={classNames.markdownContainer()}
        style={{
          height: isCollapsable && isCollapsed ? MAX_HEIGHT : undefined,
        }}
        ref={ref}
      >
        <Markdown content={content || 'Sem descrição'} />
        {isCollapsable && isCollapsed && (
          <div
            data-testid="shadow"
            className={classNames.shadow()}
            style={{ height: MAX_HEIGHT / 2 }}
          />
        )}
      </div>
      {isCollapsable && (
        <>
          <Spacer size="4" axis="vertical" />
          <Flex justify="center">
            <Button
              variant="outline"
              size="xs"
              onClick={() => {
                setIsCollapsed((prevState) => {
                  if (!prevState) {
                    ref.current?.scrollIntoView({
                      behavior: 'instant',
                    });
                  }

                  return !prevState;
                });
              }}
            >
              {isCollapsed ? 'Ver Mais' : 'Ver Menos'}
            </Button>
          </Flex>
        </>
      )}
    </Flex>
  );
}
